import React, { useCallback, useEffect, useMemo, useState } from "react";
import {useQuery} from "react-query";
import {authenticatedRequestRaw} from "../../../services/api.service";
import {useHistory, useParams} from "react-router-dom";
import {ActivityType} from "../../../typings/activity";
import Quiz from "./partials/quiz";
import Modal from "../../../components/UI/Modal";
import Button from "../../../components/UI/Button";
import Task from "./partials/task";
import FeedbackQuiz from "./partials/feedback-quiz";
import Reading from "./partials/reading";
import Video from "./partials/video";
import FeedbackTask from "./partials/feedback-task";
import { CourseDetail as CourseDetailType } from "../../../typings/course";
import { useBreadcrumbSetter } from "../../../hooks/useBreadcrumbSetter";

const Activity: React.FC = () => {
	const history  = useHistory();
	const params:any  = useParams();
	const [activityId, setActivityId] = useState<number | null>(null);
  const [course, setCourse] = useState<CourseDetailType | null>(null);
	const { data: activity, refetch } = useQuery<ActivityType>('activityDetail', async () => {
		const response = await authenticatedRequestRaw('GET','/course/activity/' + activityId)
		return response?.data?.data
	}, {enabled: false})
  const {
    data: dataCourse,
    refetch: refetchCourse,
  } = useQuery(
    "courseDetail",
    async () => {
      const response = await authenticatedRequestRaw(
        "GET",
        "/course/" + activity?.course_id
      );
      return response?.data?.data;
    },
    { enabled: false }
  );
	const [modalBack, showModalBack] = useState(false)
	useEffect(() => {
		if(isNaN(params?.id)){
			history.push('/dashboard')
		}
		setActivityId(Number(params?.id));
	},[]) // eslint-disable-line react-hooks/exhaustive-deps
	useEffect(() => {
    if (activityId) {
      refetch();
    }
  }, [activityId, refetch]);
  useEffect(() => {
    if (activity) {
      refetchCourse();
    }
  }, [activity, refetchCourse]);
  useEffect(() => {
    if (dataCourse) {
      setCourse(dataCourse);
    }
  }, [dataCourse]);

	const render = () => {
		if(activity){
			switch (activity.type){
				case 'quiz':
					if(activity.memberActivities){
						return <FeedbackQuiz activity={activity} />
					}
					return <Quiz activity={activity} />
				case 'task':
					if(activity.memberActivities){
						return <FeedbackTask activity={activity} />
					}
					return <Task activity={activity} />
				case 'reading':
					return <Reading activity={activity} />
				case 'video':
					return <Video activity={activity} />
			}
		}
	}
	const getTitle = useCallback(() => {
		if(activity){
			switch (activity.type){
				case 'quiz':
					return 'Kuis'
				case 'task':
					return 'Tugas'
				case 'reading':
					return 'Bacaan'
				case 'video':
					return 'Video'
			}
		}
    return '-'
	},[activity]);
  const breadcrumbs = useMemo(
    () => [
      { label: "Belajar", path: "/course" },
      { label: course?.name || "-", path: "/course/" + course?.id },
      { label: getTitle(), isLast: true },
    ],
    [course, getTitle]
  );
  useBreadcrumbSetter(breadcrumbs);
	return (
    <>
      {render()}
      <Modal
        show={modalBack}
        onHide={() => {
          showModalBack(false);
        }}
      >
        <Modal.Body>
          Anda yakin akan meninggalkan halaman ini? data anda tidak akan
          tersimpan
        </Modal.Body>
        <Modal.Footer>
          <Button
            outline
            onClick={() => {
              showModalBack(false);
            }}
          >
            Batal
          </Button>
          <Button
            primary
            className={"min-w-75px"}
            onClick={() => history.push(`/course/${activity?.course_id}`)}
          >
            Ya
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Activity
